// extracted by mini-css-extract-plugin
export default {"title":"StarQuestion_title__20sMA","optional":"StarQuestion_optional__XNp-t","stars":"StarQuestion_stars__0W4T+","star":"StarQuestion_star__frfVC"};